import { registerEnumType } from 'type-graphql'

export enum QuestionTypeEnum {
  Mcq = 'mcq',
  TrueFalse = 'truefalse',
  Identification = 'identification',
  Enumeration = 'enumeration',
  Open = 'Open',
}

registerEnumType(QuestionTypeEnum, {
  name: 'QuestionTypeEnum',
  description: 'Question type that determines how an answer is graded',
})
